import { useAPIAction, ColorCollectionsDraftApi } from "melco-shared-logic";

export const useAddColorCollection = () =>
  useAPIAction(
    ColorCollectionsDraftApi,
    async (api) => {
      const data = await api.userColorCollectionsAddDraft({
        sharedserviceMelcoModelsAddColorCollection: {
          service: "embroidery",
          color_list: [],
        },
      });

      return {
        successMessages: [
          {
            message: "default",
          },
        ],
        data,
      };
    },
    {
      translationPrefix: "color_collections.actions.add",
    }
  );
